import { useCapabilitiesStore } from '@/stores/capabilities'
import { FEATURES, useFeaturesStore } from '@/stores/features'
import { useRoomStore } from '@/stores/room'

interface UseMicrophoneVolumeStateProps {
  memberId: string
}

export const useMicrophoneVolumeState = ({
  memberId,
}: UseMicrophoneVolumeStateProps) => {
  const selfMemberId = useRoomStore(state => state.memberId)
  const isSelf = memberId === selfMemberId

  const microphoneVolumeCapability = useCapabilitiesStore(state =>
    isSelf
      ? state.selfMicrophoneVolumeCapability
      : state.memberMicrophoneVolumeCapability,
  )

  const isFeatureDisabled = useFeaturesStore(state =>
    isSelf
      ? state.disabled.SELF_MICROPHONE_VOLUME ===
        FEATURES.SELF_MICROPHONE_VOLUME
      : state.disabled.MEMBER_MICROPHONE_VOLUME ===
        FEATURES.MEMBER_MICROPHONE_VOLUME,
  )

  // button visible if one of the capabilities is enabled and FF is enabled
  const isMicrophoneVolumeVisible =
    !isFeatureDisabled && microphoneVolumeCapability

  const isMicrophoneVolumeEnabled = microphoneVolumeCapability

  return { isMicrophoneVolumeEnabled, isMicrophoneVolumeVisible }
}
